export default __webpack_public_path__ + "static/media/001-linkedin.cc1efbf7.svg";